<ng-container>
  <div class="link-dd-wrap" [ngClass]="{'dd-open': active}" wrapperComponent  [(active)]="active">
    <button class="nav-link btn btn-flat" (click)="setMaxWidth()" translate componentLink>{{cmsLink}}</button>
    <div class="dd" id="cms-embeded{{cmsId?'-'+cmsId:''}}" componentContent>
      @if (!hideCloseBtn) {
        <span class="close-btn" closeComponent>&times;</span>
      }
      <cms class="cms-content{{cmsId?'-'+cmsId:''}}" [title]="cmsTitle"></cms>
    </div>
  </div>
</ng-container>
<ng-template #MobileTpl>
  <cms class="cms-content{{cmsId?'-'+cmsId:''}}" [title]="cmsTitle"></cms>
</ng-template>
